"use client";
import React from "react";
import { PageTextOnlyLPSchema } from "@/sanity/pages/PageTextOnlyLPTemplate";
import NavBarV2 from "@/components/global/partials/HeaderV2";
import Footer from "@/components/global/partials/Footer";
import HeroSection from "../pageComponents/text-only/Hero";
import TextWithCertificateSection from "../pageComponents/text-only/TextWithCertificate";
import ThisPageSection from "../pageComponents/text-only/ThisPage";
import EmergedSection from "../pageComponents/text-only/Emerged";
import bg from "@/public/home/section-bg.jpg";
import Image from "@/helpers/Image";
import Wins from "../pageComponents/text-only/Wins";
import PropTrading from "../pageComponents/text-only/PropTrading";
import LastCTASection from "../global/sections/LastCTA";
import { cn } from "@/lib/utils";
import HistorySection from "../pageComponents/text-only/HistorySection";
import logo from "@/public/logo-black.svg";
import { Motion } from "../global/utils/Motion";

export default function PageTextOnlyLPJSX({
  data,
}: {
  data: PageTextOnlyLPSchema;
}) {
  return (
    <>
      {/*{data?.settings?.header && (
        <NavBarV2 headerData={data?.settings?.header} animate={true} />
      )}*/}
      <nav
        className={cn(
          "flex absolute z-40 justify-center items-end w-full lg:px-0 top-[4rem] start-0 px-[4rem] lg:top-[9rem]",
        )}
      >
        <Motion
          className="flex relative justify-center items-center mx-auto w-full max-w-[187.375rem] py-[1.5rem] lg:py-0"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <a href="/">
            <Image alt="Logo" src={logo} className="w-[16.375rem]" />
          </a>
        </Motion>
      </nav>

      <HeroSection data={data} />

      <div
        className={cn(
          "relative overflow-clip py-[5rem] lg:py-[7rem] px-[2rem] lg:px-0",
        )}
      >
        <div className="hidden absolute top-0 left-1/2 -translate-x-1/2 w-[38.25rem] sm:w-[55rem] lg:w-[min(180rem,80%)] h-full lg:flex justify-between opacity-50 lg:opacity-100">
          {Array.from({ length: 7 }).map((_, index) => (
            <div
              key={index}
              className={cn(
                "h-full border-l border-l-[#E5E5E5]",
                index >= 2 && index < 5 && "border-l-transparent",
                index >= 5 && "hidden lg:block",
              )}
            />
          ))}
        </div>
        <div className="lg:hidden absolute top-0 left-1/2 -translate-x-1/2 w-[49.25rem] sm:w-[55rem] lg:w-[min(180rem,80%)] h-full flex justify-between">
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={index}
              className={cn("h-full border-l border-l-[#E5E5E5]")}
            />
          ))}
        </div>
        <div className="w-[min(94.375rem,100%)] mx-auto flex flex-col items-start relative ">
          <HistorySection data={data} />
          <TextWithCertificateSection data={data} />

          <div className="relative w-full" style={{ overflowAnchor: "none" }}>
            <div className="relative overflow-clip w-[min(229.25rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem]">
              <div className="absolute top-0 left-0 w-full h-full pointer-events-none bg-[#E6EDE9]">
                <Image
                  className="absolute left-1/2 -translate-x-1/2 bottom-0 !w-[max(100%,120rem)] !max-w-none !h-auto object-cover mix-blend-luminosity opacity-[.10]"
                  style={{
                    maskImage:
                      "linear-gradient(to top, black 20%, transparent 100%)",
                    WebkitMaskImage:
                      "linear-gradient(to top, black 20%, transparent 100%)",
                  }}
                  src={bg}
                  quality={100}
                  alt="background art"
                />
              </div>
              <Wins data={data} />
            </div>
          </div>
          <ThisPageSection data={data} />

          <div className="relative w-full" style={{ overflowAnchor: "none" }}>
            <div className="relative overflow-clip w-[min(229.25rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem]">
              <div className="absolute top-0 left-0 w-full h-full pointer-events-none bg-[#103037]">
                <Image
                  className="absolute left-1/2 -translate-x-1/2 bottom-0 !w-[max(100%,120rem)] !max-w-none !h-auto object-cover mix-blend-luminosity opacity-[.05]"
                  style={{
                    maskImage:
                      "linear-gradient(to top, black 20%, transparent 100%)",
                    WebkitMaskImage:
                      "linear-gradient(to top, black 20%, transparent 100%)",
                  }}
                  src={bg}
                  quality={100}
                  alt="background art"
                />
              </div>
              <PropTrading data={data} />
            </div>
          </div>

          <EmergedSection data={data} />
        </div>
      </div>

      <LastCTASection
        chip={data?.lastChip}
        text={data?.lastText}
        cta={data?.lastCTA}
        textClassName="w-[min(80rem,90%)]"
        ctaClassName="mb-[14rem] lg:mb-0"
      />
      {data?.settings?.footer && (
        <Footer
          data={data.settings.footer}
          slug={data?.settings?.slug?.current}
        />
      )}
    </>
  );
}
